import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// https://github.com/mrdoob/three.js/blob/master/src/core/Clock.js
export default class Clock {
  constructor(autoStart = true) {
    _defineProperty(this, "autoStart", void 0);
    _defineProperty(this, "startTime", 0);
    _defineProperty(this, "oldTime", 0);
    _defineProperty(this, "running", false);
    _defineProperty(this, "elapsedTime", 0);
    this.autoStart = autoStart;
  }
  start() {
    this.startTime = (typeof performance === 'undefined' ? Date : performance).now();
    this.oldTime = this.startTime;
    this.elapsedTime = 0;
    this.running = true;
  }
  stop() {
    this.getElapsedTime();
    this.running = false;
    this.autoStart = false;
  }
  getElapsedTime() {
    this.getDelta();
    return this.elapsedTime;
  }
  getDelta() {
    let diff = 0;
    if (this.autoStart && !this.running) {
      this.start();
      return 0;
    }
    if (this.running) {
      const newTime = (typeof performance === 'undefined' ? Date : performance).now();
      diff = (newTime - this.oldTime) / 1000;
      this.oldTime = newTime;
      this.elapsedTime += diff;
    }
    return diff;
  }
}